export default "__VITE_ASSET__9gS6gkPQ__"